import { ReactNode } from 'react';
import { Input } from 'antd';
import FloatInput from './FloatInput';

export type FloatInputWithUnitProps = {
  value?: number | null;
  onChange?: (value: number | null) => void;
  disabled?: boolean;
  allowNegative?: boolean;
  unit?: string | null;
  unitSuffix?: ReactNode;
  inputWidth?: number;
};

/**
 * A FloatInput combined with a unit display in an Input.Group.
 * The unit is displayed as a disabled input that auto-grows based on unit length.
 *
 * Usage:
 * <Form.Item label="Menge" name="quantity">
 *   <FloatInputWithUnit unit="kg" onChange={handleChange} />
 * </Form.Item>
 */
const FloatInputWithUnit = (props: FloatInputWithUnitProps) => {
  const { value, onChange, disabled, allowNegative, unit, unitSuffix, inputWidth = 90 } = props;

  const hasUnit = unit || unitSuffix;

  if (!hasUnit) {
    return (
      <FloatInput
        style={{ width: inputWidth }}
        value={value}
        onChange={onChange}
        disabled={disabled}
        allowNegative={allowNegative}
      />
    );
  }

  return (
    <Input.Group compact>
      <FloatInput
        style={{ width: inputWidth }}
        value={value}
        onChange={onChange}
        disabled={disabled}
        allowNegative={allowNegative}
      />
      <Input
        value={unit || ''}
        disabled
        style={{
          width: `${Math.max(8, (unit?.length || 0) + 2)}ch`,
          minWidth: 80,
          textAlign: 'center',
        }}
        suffix={unitSuffix}
      />
    </Input.Group>
  );
};

export default FloatInputWithUnit;
